// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".notSelect[data-v-47b43f9e] {\n  opacity: 0.3;\n}", "",{"version":3,"sources":["/spug/spug_api/repos/119_10566_20260928180206/packages/kankan-laser/src/views/space-division/style.scss","/spug/spug_api/repos/119_10566_20260928180206/packages/kankan-laser/src/views/space-division/index.vue"],"names":[],"mappings":"AAAA;EACE,YAAA;ACCF","file":"index.vue","sourcesContent":[".notSelect {\n  opacity: 0.3;\n}\n",".notSelect {\n  opacity: 0.3;\n}"]}]);
// Exports
module.exports = exports;
